import { render, staticRenderFns } from "./CRMConfig.vue?vue&type=template&id=532c1fb5&"
import script from "./CRMConfig.vue?vue&type=script&lang=js&"
export * from "./CRMConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports